export default __webpack_public_path__ + "static/mainLoader-bbbd800c32f0f829583ef4bc3b8cc213.webm";